import { gql } from "@apollo/client";

const MARK_NOTIFICATIONS_READ = gql`
  mutation MarkNotifications($input: MarkNotificationsInput!) {
    markNotifications(input: $input) {
      notifications {
        id
        title
        content
        actionText
        actionUrl
        readAt
        createdAt
      }
    }
  }
`;

export default MARK_NOTIFICATIONS_READ;
